//import React, {Component} from 'react';
import React from 'react';
import PropTypes from 'prop-types';
//import { withStyles } from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core";
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import {makeStyles} from '@material-ui/core/styles';
import CardHeader from '@material-ui/core/CardHeader';
import Collapse from '@material-ui/core/Collapse';
import Avatar from '@material-ui/core/Avatar';
import {red} from '@material-ui/core/colors';
import FavoriteIcon from '@material-ui/icons/Favorite';
import ShareIcon from '@material-ui/icons/Share';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import MoreVertIcon from '@material-ui/icons/MoreVert';
//import Icon from '@material-ui/core/Icon';
//import Button from '@material-ui/core/Button';
//import IconButton from '@material-ui/core/IconButton';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import clsx from 'clsx';


/* const styles = {


};*/

const styles = theme => ({
    margin: {
        margin: theme.spacing.unit * 2,
    },
    extendedIcon: {
        marginRight: theme.spacing.unit * 8,
    },
    card: {
        maxWidth: 800,
        backgroundColor:'#fad29d',
        borderWidth:2,
        borderColor:'black',
        marginBottom:'10px',
        elevation:10,
        square:true
    },

    media: {
        height: 0,
        paddingTop: '56.25%', // 16:9
    },
    expand: {
        transform: 'rotate(0deg)',
        marginLeft: 'auto',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    avatar: {
        backgroundColor: red[500],
    },

});


//'url(' + require('../../images/IMG_1.JPG')
class CardFaxRecord extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            age: '',
            name: 'Farshid',
            testnumber: '1232322',
            labelWidth: 0,
            open:false,
            expanded:false,
        };
        //const unsubscribe = store.subscribe( () => {/*console.log(store.getState())*/});
        this.deleteImageClick = this.deleteImageClick.bind(this);
        this.editImageClick = this.editImageClick.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.PaperComponent = this.PaperComponent.bind(this);
        this.handleDelete = this.handleDelete.bind(this);
        this.handleExpandClick = this.handleExpandClick.bind(this);


    }


    deleteImageClick(argData){

        //alert('delete was 1 called');
        // this.props.onDelete(argData.id);
        this.setState({ open: true });


    }

    editImageClick(argData){
        //alert('edit was  1 called');
        /*const { data} = this.props;
        data.forEach((item)=>{item.editMode = false});
        if(argData.editMode){
            if(argData.editMode == true) {

                argData.editMode = false;
            }else{
                argData.editMode = true;
            }
        }else{
            argData.editMode = true;
        }
        */

        this.props.onEdit(argData);
    }

    handleClickOpen(){
        this.setState({ open: true });
    };

    handleClose(){
        this.setState({ open: false });
    };

    handleDelete(){
        this.props.onDelete(this.props.info.id);
        this.setState({ open: false });
    };

    PaperComponent(props) {
        return (
            <Draggable cancel={'[class*="MuiDialogContent-root"]'}>
            <Paper {...props} />
        </Draggable>
    );
    }


    handleExpandClick() {
        //setExpanded(!expanded);

        this.setState({ expanded: !this.state.expanded });
    }

    render() {
        const {classes} = this.props;
        // const classes2 = useStyles();

        return (
            <Card className={classes.card}>
            <CardHeader
        avatar={
            <Avatar aria-label="recipe" className={classes.avatar}>
            R
            </Avatar>
    }
        action={
            <IconButton aria-label="settings">
            <MoreVertIcon />
            </IconButton>
    }
        title="Shrimp and Chorizo Paella"
        subheader="September 14, 2016"
            />
            <CardMedia
        className={classes.media}
        image="/static/images/cards/paella.jpg"
        title="Paella dish"
            />
            <CardContent>
            <Typography variant="body2" color="textSecondary" component="p">
            This impressive paella is a perfect party dish and a fun meal to cook together with your
            guests. Add 1 cup of frozen peas along with the mussels, if you like.
        </Typography>
        </CardContent>
        <CardActions disableSpacing>
        <IconButton aria-label="add to favorites">
            <FavoriteIcon />
            </IconButton>
            <IconButton aria-label="share">
            <ShareIcon />
            </IconButton>
            <IconButton
        className={clsx(classes.expand, {
            [classes.expandOpen]: this.state.expanded,
        })}
        onClick={this.handleExpandClick}
        aria-expanded={this.state.expanded}
        aria-label="show more"
        >
        <ExpandMoreIcon />
        </IconButton>
        </CardActions>
        <Collapse in={this.state.expanded} timeout="auto" unmountOnExit>
        <CardContent>
        <Typography paragraph>Method:</Typography>
        <Typography paragraph>
        Heat 1/2 cup of the broth in a pot until simmering, add saffron and set aside for 10
            minutes.
            </Typography>
            <Typography paragraph>
        Heat oil in a (14- to 16-inch) paella pan or a large, deep skillet over medium-high
        heat. Add chicken, shrimp and chorizo, and cook, stirring occasionally until lightly
        browned, 6 to 8 minutes. Transfer shrimp to a large plate and set aside, leaving chicken
        and chorizo in the pan. Add pimentón, bay leaves, garlic, tomatoes, onion, salt and
        pepper, and cook, stirring often until thickened and fragrant, about 10 minutes. Add
        saffron broth and remaining 4 1/2 cups chicken broth; bring to a boil.
        </Typography>
        <Typography paragraph>
        Add rice and stir very gently to distribute. Top with artichokes and peppers, and cook
        without stirring, until most of the liquid is absorbed, 15 to 18 minutes. Reduce heat to
        medium-low, add reserved shrimp and mussels, tucking them down into the rice, and cook
        again without stirring, until mussels have opened and rice is just tender, 5 to 7
        minutes more. (Discard any mussels that don’t open.)
    </Typography>
        <Typography>
        Set aside off of the heat to let rest for 10 minutes, and then serve.
        </Typography>
        </CardContent>
        </Collapse>
        </Card>
    );
    }//end of render
}//End of class

CardFaxRecord.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CardFaxRecord);